import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

class ActionMomentSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      label: 'name',
      title: 'Tipo',
      items: [
        {id: 'OPEN_DOOR_BY_MIN_RSSI_AND_WHITELIST_AND_PRODUCTION_BUTTON', name: 'OPEN_DOOR_BY_MIN_RSSI_AND_WHITELIST_AND_PRODUCTION_BUTTON'}
      ]
    };
  }
}

ActionMomentSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ActionMomentSelector;



// WEBPACK FOOTER //
// ./src/gateways/component/ActionMomentSelector.js